<template>
  <div class="rules columns">
    <div class="column pane expressions">
      <h3>Rules</h3>
      <div class="list" @mouseleave="highlightRule(null)">
        <div class="rule item"
          v-for="rule of testResults"
          :key="rule.key"
          :class="{ highlight: highlightedRule === rule }"
          @mouseenter="highlightRule(rule)">
          <i
            class="result icon fas"
            :class="[rule.result.result ? 'ok fa-check' : 'err fa-times']" />
          <span class="label" v-text="rule.label" />
          <span class="actual" v-text="rule.result.input" />
        </div>
      </div>
    </div>

    <!-- Test deck -->
    <div class="column pane test-deck">
      <h3>Test Deck <small><button @click="changingTestDeck = !changingTestDeck">Edit</button></small></h3>
      <div v-if="changingTestDeck">
        <textarea
          v-model="testDeckList"
          class="test-deck-list-input"
          placeholder="1 Pepperoni (PZA) 420" />
        <button @click="pullTestDeck()">Fetch</button>
      </div>
      <div class="deck" v-else>
        <div
          v-for="(card, idx) of sortedTestCards"
          :key="idx">
          <hr v-if="card.board === 'side' && sortedTestCards[idx - 1].board === 'main'" />
          <div
            class="test-card"
            :class="{ inactive: highlightedRule && !highlightedCards.includes(card) }">
            <span>{{ card.quantity }}</span>
            <span>{{ card.name }}</span>
            <span>({{ card.set }})</span>
            <span>{{ card.code }}</span>
            <div class="colors">
              <span
                v-for="color of card.card.colors"
                :key="color"
                :class="['color', color]">
                <span :class="['icon', getColorIcon(color)]" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DeckHelper from '@/mixins/DeckHelper'
import ApiHelper from '@/mixins/ApiHelper'
import Validator from '@/mixins/Validator'

const v = new Validator()

export default {
  name: 'Rules',
  mixins: [DeckHelper, ApiHelper],

  data () {
    return {
      changingTestDeck: true,
      testDeckList: '',
      testDeck: {},
      highlightedCards: [],
      highlightedRule: null
    }
  },

  computed: {
    ...mapState(['rules']),
    sortedTestCards () {
      return (this.testDeck.cards || [])
        .sort((a, b) => {
          if (a.board === b.board) {
            return 0
          }
          return a.board === 'main' ? -1 : 1
        })
    },

    testResults () {
      const rules = this.rules.filter((r) => r.template === 'mtga')
      const res = v.evaluate(this.testDeck.cards || [], rules)
      return res
    },

    txProps () {
      return Validator.properties
    }
  },

  methods: {
    pullTestDeck () {
      this.apiRequest('deck/parse-list', {
        method: 'post',
        data: {
          list: this.testDeckList
        }
      })
      .then(({ data }) => {
        this.testDeck = {
          cards: data.deck
        }
        this.changingTestDeck = false
      })
    },

    highlightRule (rule) {
      if (!rule) {
        this.highlightedCards = []
        this.highlightedRule = null
        return
      }
      this.highlightedCards = rule.result.matches
      this.highlightedRule = rule
    }
  }
}
</script>

<style scoped>
.columns {
  display: grid;
  grid-template-columns: auto 350px;
  grid-gap: 1em;
}
.column {
  overflow: hidden;
}
.column > h3 {
  margin: 0;
  padding: 0.5em;
  background: #eee;
  border-bottom: 1px solid #999;
}
.column > .list > .item {
  padding: 0.5em;
  align-items: center;
}
.column > .list > .item.highlight {
  background-color: #eef;
}
.column > .list > .item + .item { border-top: 1px solid #999; }

.test-deck .test-card {
  display: grid;
  grid-template-columns: 2em 12em 3em 3em 5em;
  will-change: opacity, filter;
  transition: all 150ms ease-out;
}
.test-card.inactive {
  filter: saturate(0.5) grayscale(0.5);
  opacity: 0.25;
}
.test-deck .deck {
  padding: 1rem;
  font-size: small;
}
.test-deck-list-input {
  padding: 1em;
  width: 100%;
  border: 0 0 1px 0;
  min-height: 300px;
}
.test-deck-list-input + button {
  margin: 1em;
}

/* @todo Stolen from submissions view */
.color {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 1em;
  height: 1em;
  background-color: gray;
}
.color .icon { font-size: 0.7em; }
.color.W { background-color: lightgoldenrodyellow; }
.color.B { background-color: lightgray; }
.color.U { background-color: lightskyblue; }
.color.R { background-color: lightcoral; }
.color.G { background-color: lightgreen; }

.result.icon {
  display: inline-block;
  width: 2em;
  text-align: center;
  margin-right: 0.5em;
}
.result.icon.ok { color: forestgreen; }
.result.icon.err { color: crimson; }

.rule .actual {
  float: right;
}
</style>
